import { render, staticRenderFns } from "./complaint-item.vue?vue&type=template&id=204d3bf6&scoped=true"
import script from "./complaint-item.vue?vue&type=script&lang=js"
export * from "./complaint-item.vue?vue&type=script&lang=js"
import style0 from "./complaint-item.vue?vue&type=style&index=0&id=204d3bf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d3bf6",
  null
  
)

export default component.exports